import { useMemo } from 'react'
import ROUTE from 'constant/route'
import { get, isEmpty, values } from 'lodash-es'
import { AdminRouteName } from './IRouteConstant'
import QuickServiceIcon from '@mui/icons-material/PointOfSale'
import OnlineStoreIcon from '@mui/icons-material/Store'
import IntegrationIcon from '@mui/icons-material/IntegrationInstructions'
import VendorsIcon from '@mui/icons-material/Contacts'
import InventoryIcon from '@mui/icons-material/Inventory2'
import OnlineOrderIcon from '@mui/icons-material/BookOnline'
import CloseOfDayIcon from '@mui/icons-material/EventAvailable'
import OnlineMenuBuilderIcon from '@mui/icons-material/BuildCircle'
import DashboardIcon from '@mui/icons-material/Dashboard'
import ComboIcon from '@mui/icons-material/Bento'
import IngredientsIcon from '@mui/icons-material/SetMeal'
import ProductIcon from '@mui/icons-material/Fastfood'
import CategoryIcon from '@mui/icons-material/Category'
import SettingIcon from '@mui/icons-material/Settings'
import ReportIcon from '@mui/icons-material/Summarize'
import POSMenuIcon from '@mui/icons-material/MenuBook'
import POSSaleProcessingIcon from '@mui/icons-material/AccountTree'
import POSContitionsIcon from '@mui/icons-material/QuestionAnswer'
import TableServiceIcon from '@mui/icons-material/TableBar'
import ReceiptSettingIcon from '@mui/icons-material/ReceiptLong'
import TerminalIcon from '@mui/icons-material/DesktopWindows'
import PrinterIcon from '@mui/icons-material/Print'
import HardwareAgentsIcon from '@mui/icons-material/SmartToy'
import PaymentIcon from '@mui/icons-material/Payment'
import PriceListIcon from '@mui/icons-material/CurrencyExchange'
import DiscountIcon from '@mui/icons-material/Discount'
import GiftCardIcon from '@mui/icons-material/CardGiftcard'
import UserIcon from '@mui/icons-material/People'
import TimeClockIcon from '@mui/icons-material/MoreTime'
import CustomerIcon from '@mui/icons-material/SupervisedUserCircleRounded'
import CustomerCategoryIcon from '@mui/icons-material/FolderShared'
import LocationSettingIcon from '@mui/icons-material/LocationOn'
import CompanySettingIcon from '@mui/icons-material/MapsHomeWork'
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech'
import PersonIcon from '@mui/icons-material/Person'
import DeviceIcon from '@mui/icons-material/Devices'
import {
    POS_SETUP_MANAGE_MENUS,
    POS_SETUP_MANAGE_SALES_PROCESSING,
    POS_SETUP_MANAGE_TABLE_LAYOUT,
    POS_SETUP_MANAGE_VOID_COMP_REASONS,
    REPORT_READ_DAILY_SALE,
    ROLE_ALL,
    USER_ALL,
    ONLINE_STORE_MANAGEMENT_MANAGE_ONLINE_STORE,
    CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER,
    PRICE_LIST_MANAGEMENT_MANAGE_PRICE_LIST,
    FINANCIAL_MANAGEMENT_GENERAL,
    ORDER_EVENT_MANAGE_ORDER_EVENT,
    REPORT_RUN_CLOSE_OF_DAY,
    REPORT_INVENTORY_REPORT,
    REPORT_INVENTORY_REPORT_COGS,
    REPORT_EMPLOYEE_REPORT,
    REPORT_CLOSURE_HISTORY_REPORT,
    SALES_ONLINE_ORDER,
    VENDOR_MANAGEMENT_MANAGE_VENDOR,
    INVENTORY_MANAGEMENT_MANAGE_INVENTORY,
    PRODUCT_MANAGEMENT_PRODUCT,
    REPORT_CLOSURE_HISTORY,
    DASHBOARD_DASHBOARD_ADMIN,
    POS_SETUP_MANAGE_PAYMENT,
    POS_SETUP_MANAGE_PAY_IN_OUT_REASONS,
    POS_SETUP_MANAGE_MENU_VIEWS,
    ONLINE_STORE_MANAGEMENT_MENU_MANAGEMENT,
    ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT,
    SYSTEM_SETUP_COMPANY_BRANDS,
    SYSTEM_SETUP_SUBSCRIPTION,
    PRODUCT_MANAGEMENT_COMBOS,
    PRODUCT_MANAGEMENT_INGREDIENTS,
    PRODUCT_MANAGEMENT_ISSUE_GIFT_CARD,
    PRODUCT_MANAGEMENT_MANIPULATE_GIFT_CARD,
    DISCOUNT_DISCOUNT_MANAGEMENT,
    RECEIPT_AND_REPORT_MANAGEMENT_MANAGE_RECEIPT,
    REPORT_MANAGEMENT_MANAGE_REPORT,
    USERS_NOTIFICATION_GROUPS,
    SYSTEM_SETUP_CLOSEING_PROCEDURE,
    SYSTEM_SETUP_FULTILLMENT_OPTIONS,
    SYSTEM_SETUP_DEVICE_MANAGEMENT,
    SYSTEM_SETUP_GENERAL,
    SYSTEM_SETUP_GIFT_CARD,
    SYSTEM_SETUP_TIME_CLOCK,
    SYSTEM_SETUP_ORDER_CHANNEL,
    SYSTEM_SETUP_ORDER_NUMBER,
    SYSTEM_SETUP_INTEGRATIONS_PAYMENT,
    FINANCIAL_MANAGEMENT_COMPANY_DETAILS,
    FINANCIAL_MANAGEMENT_TAXES,
    FINANCIAL_MANAGEMENT_GLCODES_MANAGEMENT,
    FINANCIAL_MANAGEMENT_PAYMENT_ACCOUNT,
    FINANCIAL_MANAGEMENT_PAYMENT_METHOD,
    REPORT_ACCOUNTING_JOURNAL,
    POS_SETUP_GENERAL,
    SYSTEM_SETUP_LOCATION_BRANDS,
    SALES_RESET_SALES,
    CUSTOMER_MANAGEMENT_LOYALTY_SETTING_MANAGEMENT,
} from 'constant/permissions'

import { AuthRoute } from './AuthRoute'
import { useTranslation } from 'react-i18next'
import { IMenu, IMenuNav } from 'components/SideNavigation/SideNavigation'
import { ILinkTab, IRoute } from 'interfaces'
import usePermission from 'hooks/usePermission/usePermission'
import LazyRetry from 'components/LazyRetry/LazyRetry'
import nameof from 'utilities/nameof'
import { useAppSelector } from 'store/useStoreHook'
import FeedIcon from '@mui/icons-material/Feed'
// import { useFeatureFlagEnabled } from 'posthog-js/react'
import { OperationalSettingContract } from 'models'
import UOMIcon from '@mui/icons-material/Scale'
import UOMClassesLookup from 'views/UOMs/UOMClassesLookup/UOMClassesLookup'
import UOMsLookup from 'views/UOMs/UOMsLookup/UOMsLookup'
import NewUOM from 'views/UOMs/NewUOM/NewUOM'
import EditUOM from 'views/UOMs/NewUOM/EditUOM'
import { FeatureFlag } from 'constant/featureFlag'
import { getActiveFeatureFlags } from 'utilities/featureFlags/featureFlagsUtil'
import { useActiveFeatureFlags } from 'posthog-js/react'
const OPERATIONAL_SETTING = nameof<OperationalSettingContract>()
const NewComboSet = LazyRetry(
    () => import('views/Products/NewComboSet/NewComboSet'),
)
const LoyaltyManagement = LazyRetry(
    () => import('pages/CustomerLoyaltyPage/Tabs/LoyaltyManagement'),
)
const LoyaltyHistory = LazyRetry(
    () => import('pages/CustomerLoyaltyPage/Tabs/LoyaltyHistory'),
)
const TimeClockSettingPage = LazyRetry(
    () => import('pages/EmployeeTimeClockSettingPage/TimeClockSettingPage'),
)
const AccountReportPage = LazyRetry(
    () => import('pages/AccountReportPage/AccountReportPage'),
)
const TerminalReportPage = LazyRetry(
    () => import('views/TerminalReport/TerminalReportPage'),
)
const ReportSettingPage = LazyRetry(
    () => import('pages/ReportSettingPage/ReportSettingPage'),
)
const IngredientsPage = LazyRetry(
    () => import('pages/IngredientsPage/IngredientsPage'),
)
const VendorsPage = LazyRetry(() => import('pages/VendorsPage/VendorsPage'))
const Vendors = LazyRetry(() => import('views/Vendors/Vendors'))
const NewVendor = LazyRetry(() => import('views/Vendors/NewVendor/NewVendor'))
const EditVendor = LazyRetry(() => import('views/Vendors/NewVendor/EditVendor'))

const InventoryLookupPage = LazyRetry(
    () => import('pages/InventoryLookupPage/InventoryLookupPage'),
)
const InventoryReportPage = LazyRetry(
    () => import('pages/InventoryReportPage/InventoryReportPage'),
)
const UOMsPage = LazyRetry(() => import('pages/UOMsPage/UOMsPage'))
const PosPage = LazyRetry(() => import('pages/PosPage/PosPage'))
const MenuPage = LazyRetry(() => import('pages/PosMenuPage/MenuPage'))
const PosSaleProcessingPage = LazyRetry(
    () => import('pages/PosSaleProcessingPage/PosSaleProcessingPage'),
)
const PosConditionPage = LazyRetry(
    () => import('pages/PosConditionPage/PosConditionPage'),
)
const TableLayoutPage = LazyRetry(
    () => import('pages/TableLayoutPage/TableLayoutPage'),
)
const ReceiptSettingsPage = LazyRetry(() => import('pages/ReceiptSettingsPage'))
const TerminalDevicePage = LazyRetry(
    () => import('pages/TerminalDevicePage/TerminalDevicePage'),
)
const PrinterDevicePage = LazyRetry(
    () => import('pages/PrinterDevicePage/PrinterDevicePage'),
)
const HardwareAgentPage = LazyRetry(
    () => import('pages/HardwareAgentPage/HardwareAgentPage'),
)
const DeviceIntegrationsPage = LazyRetry(
    () => import('pages/DeviceIntegrationsPage/DeviceIntegrationPage'),
)
const PaymentMethodPage = LazyRetry(
    () => import('pages/PaymentMethodPage/PaymentMethodPage'),
)
const PriceListPage = LazyRetry(
    () => import('pages/PriceListPage/PriceListPage'),
)
const DiscountPage = LazyRetry(() => import('pages/DiscountsPage/DiscountPage'))
const GiftCardsPage = LazyRetry(
    () => import('pages/GiftCardsPage/GiftCardPages'),
)
const UserPage = LazyRetry(() => import('pages/UserPage/UserPage'))
const CustomerAdminPage = LazyRetry(
    () => import('pages/CustomerAdminPage/CustomerAdminPage'),
)
const CustomerCategoriesPage = LazyRetry(
    () => import('pages/CustomerCategoriesPage/CustomerCategoriesPage'),
)
const OnlineStorePage = LazyRetry(
    () => import('pages/OnlineStorePage/OnlineStorePage'),
)
const OnlineMenuBuilderPage = LazyRetry(
    () => import('pages/OnlineMenuBuilderPage/OnlineMenuBuilderPage'),
)

const OnlineIntegrationsPage = LazyRetry(
    () => import('pages/OnlineIntegrationsPage/OnlineIntegrationsPage'),
)
const Product = LazyRetry(() => import('pages/ProductsPage/Products/Product'))
const NewProduct = LazyRetry(
    () => import('views/Products/NewProduct/NewProduct'),
)
const EditProductNew = LazyRetry(
    () => import('views/Products/NewProduct/EditProduct'),
)
const General = LazyRetry(() => import('pages/PosPage/General/General'))
const FinancialGeneral = LazyRetry(
    () => import('components/Financials/General/GeneralSetting'),
)
const CloseOfDayReportTab = LazyRetry(
    () => import('views/CloseOfDay/CloseOfDayReportTab/CloseOfDayReportTab'),
)
const CloseOfDaySummary = LazyRetry(
    () => import('views/CloseOfDay/CloseOfDaySummary/CloseOfDaySummary'),
)
const ClosingProcedure = LazyRetry(
    () =>
        import(
            'components/OperationalSetting/ClosingProcedures/closingProcedure'
        ),
)
const AccountReportContainer = LazyRetry(
    () =>
        import('pages/AccountReportPage/AccountReport/AccountReportContainer'),
)
const TerminalReportDetailPage = LazyRetry(
    () => import('components/TermialReportDetail/TerminalReportDetailPage'),
)
const SalesSummaryReport = LazyRetry(
    () => import('pages/BusinessReportPage/SaleSummary/Component'),
)
const SalesGrowthReport = LazyRetry(
    () => import('pages/BusinessReportPage/SaleGrowth/Component'),
)
const SalesDiscountReport = LazyRetry(
    () => import('pages/BusinessReportPage/Discount/Component'),
)
const SalesEmployeeReport = LazyRetry(
    () => import('pages/BusinessReportPage/Employee/Component'),
)
const SalesCategoryReport = LazyRetry(
    () => import('pages/BusinessReportPage/SaleCategory/Component'),
)
const SalesProductReport = LazyRetry(
    () => import('pages/BusinessReportPage/SaleProduct/Component'),
)
const BusinessReportPage = LazyRetry(
    () => import('pages/BusinessReportPage/BusinessReportPage'),
)
const OnlineStoresPage = LazyRetry(
    () => import('views/OnlineStore/OnlineStores/OnlineStoresPage'),
)
const NewOnlineStore = LazyRetry(
    () =>
        import('views/OnlineStore/OnlineStores/NewOnlineStore/NewOnlineStore'),
)
const EditOnlineStore = LazyRetry(
    () =>
        import('views/OnlineStore/OnlineStores/NewOnlineStore/EditOnlineStore'),
)
const OnlineOrderChannelPage = LazyRetry(
    () => import('views/OnlineStore/OrderChannels/OnlineOrderChannelPage'),
)
const NewOnlineOrderChannel = LazyRetry(
    () =>
        import(
            'views/OnlineStore/OrderChannels/NewOrderChannel/NewOrderChannel'
        ),
)
const EditOnlineOrderChannel = LazyRetry(
    () =>
        import(
            'views/OnlineStore/OrderChannels/NewOrderChannel/EditOrderChannel'
        ),
)
const OnlineMenuBuilderMainPage = LazyRetry(
    () => import('pages/OnlineMenuBuilderPage/OnlineMenuBuilderMainPage'),
)

const UpsertMenuBuilder = LazyRetry(
    () => import('pages/OnlineMenuBuilderPage/UpsertMenuBuilderPageNewer'),
)
const ClosureHistory = LazyRetry(
    () => import('views/TerminalReport/ClosureHistory/ClosureHistory'),
)
const CodClosureHistory = LazyRetry(
    () => import('views/CloseOfDay/ClosureHistory/ClosureHistory'),
)
const OnlineIntegrations = LazyRetry(
    () =>
        import(
            'pages/OnlineIntegrationsPage/OnlineIntegrations/OnlineIntegrations'
        ),
)
const OnlineIntegrationsEdit = LazyRetry(
    () =>
        import(
            'pages/OnlineIntegrationsPage/OnlineIntegrations/OnlineIntegrationsEdit'
        ),
)
const CategoriesPage = LazyRetry(
    () => import('pages/CategoriesPage/CategoriesPage'),
)
const Categories = LazyRetry(() => import('pages/CategoriesPage/Categories'))
const NewCategory = LazyRetry(
    () => import('views/Products/NewCategory/NewCategory'),
)
const EditCategory = LazyRetry(
    () => import('views/Products/NewCategory/EditCategory'),
)
const ModifierGroups = LazyRetry(
    () => import('pages/ProductsPage/ModifierGroups/ModifierGroupPage'),
)

const DepositAndCreditProduct = LazyRetry(
    () =>
        import(
            'pages/ProductsPage/DepositAndCreditProducts/DepositAndCreditProduct'
        ),
)
const DepositAndCreditProductEdit = LazyRetry(
    () =>
        import(
            'pages/ProductsPage/DepositAndCreditProducts/DepositAndCreditProductEdit'
        ),
)

const UpsertModifierGroup = LazyRetry(
    () =>
        import(
            'pages/ProductsPage/ModifierGroups/UpsertModifyGroup/UpsertModifierGroupPage'
        ),
)
const UpsertVariant = LazyRetry(
    () => import('pages/ProductsPage/Variants/UpsertVariantPage'),
)
const Variants = LazyRetry(() => import('pages/ProductsPage/Variants/Variants'))
const CombosPage = LazyRetry(() => import('pages/CombosPage/CombosPage'))
const Combos = LazyRetry(() => import('pages/CombosPage/Combos'))

const Ingredients = LazyRetry(
    () => import('pages/IngredientsPage/Ingredients/Ingredients'),
)
const NewIngredient = LazyRetry(
    () => import('views/Products/NewIngredients/NewIngredient'),
)
const EditIngredient = LazyRetry(
    () => import('views/Products/NewIngredients/EditIngredient'),
)
const InventoryLookupTab = LazyRetry(
    () => import('components/Inventory/InventoryLookupTab'),
)
const InventoryAdjustmentForm = LazyRetry(
    () =>
        import(
            'components/Inventory/InventoryAdjustment/InventoryAdjustmentForm'
        ),
)
const InventoryHistoryTab = LazyRetry(
    () =>
        import(
            'views/InventoryReportPage/InventoryHistoryTab/InventoryHistoryTab'
        ),
)
const GiftCardInventory = LazyRetry(
    () => import('components/Inventory/GiftCardInventory/GiftCardInventory'),
)
const CogsReportTab = LazyRetry(
    () => import('views/InventoryReportPage/CogsReportTab/CogsReportTab'),
)
const ServiceChargeSettingProvider = LazyRetry(
    () => import('pages/PosPage/ServiceCharges/ServiceChargeProvider'),
)
const TipsSettings = LazyRetry(
    () => import('pages/PosPage/TipsSettings/TipsSettings'),
)
const UpsertMenuPage = LazyRetry(
    () => import('pages/PosMenuPage/Menu/UpsertMenuPage'),
)
const UpsertMenuPageNewer = LazyRetry(
    () => import('pages/PosMenuPage/Menu/UpsertMenuPageNew'),
)
const Menus = LazyRetry(() => import('pages/PosMenuPage/Menu/Menus'))
const MenuView = LazyRetry(() => import('pages/PosMenuPage/MenuView/MenuView'))
const GeneralSaleRuleSetting = LazyRetry(
    () => import('pages/PosSaleProcessingPage/GeneralSaleRuleSetting'),
)
const OnlineOrderRuleSetting = LazyRetry(
    () => import('pages/PosSaleProcessingPage/OnlineOrderRuleSetting'),
)
const QuickServiceRuleSetting = LazyRetry(
    () => import('pages/PosSaleProcessingPage/QuickServiceRuleSetting'),
)
const TableServiceRuleSetting = LazyRetry(
    () => import('pages/PosSaleProcessingPage/TableServiceRuleSetting'),
)
const OrderNumberingSetting = LazyRetry(
    () => import('pages/PosConditionPage/OrderNumbering/OrderNumberSetting'),
)
const EditPayInPayOutReason = LazyRetry(
    () =>
        import(
            'pages/PosConditionPage/PayInPayOutReasons/EditPayInPayOutReason'
        ),
)
const NewPayInPayOutReason = LazyRetry(
    () =>
        import(
            'pages/PosConditionPage/PayInPayOutReasons/NewPayInPayOutReason'
        ),
)
const PayInPayOutReasons = LazyRetry(
    () =>
        import('pages/PosConditionPage/PayInPayOutReasons/PayInPayOutReasons'),
)
const VoidCompsReasonEdit = LazyRetry(
    () => import('pages/PosConditionPage/VoidCompsReasons/EditVoidCompsReason'),
)
const VoidCompsReasons = LazyRetry(
    () => import('pages/PosConditionPage/VoidCompsReasons/VoidCompsReasons'),
)
const EditTableLayout = LazyRetry(
    () => import('pages/TableLayoutPage/TableLayout/EditTableLayout'),
)
const TableLayout = LazyRetry(
    () => import('pages/TableLayoutPage/TableLayout/TableLayout'),
)
const EditReceipt = LazyRetry(
    () => import('components/ReceiptAndReportSettings/EditReceipt'),
)
const PosTerminalDevices = LazyRetry(
    () =>
        import(
            'pages/TerminalDevicePage/PosTerminalDevices/PosTerminalDevices'
        ),
)
const UpsertPosTerminalDevicePage = LazyRetry(
    () =>
        import(
            'pages/TerminalDevicePage/PosTerminalDevices/UpsertPosTerminalDevice/UpsertPosTerminalDevicePage'
        ),
)
const PosTerminalConnectivity = LazyRetry(
    () =>
        import(
            'pages/TerminalDevicePage/PosTerminalDevices/PosTerminalConnectivity'
        ),
)
const AccountingCodes = LazyRetry(
    () => import('components/Financials/AccountingCodes/AccountingCodes'),
)
const PaymentAccounts = LazyRetry(
    () => import('components/Financials/Accounts/PaymentAccounts'),
)
const CompanyDetail = LazyRetry(
    () => import('components/Financials/CompanyDetail/CompanyDetail'),
)
const Taxes = LazyRetry(() => import('pages/FinancialPage/Taxes/TaxesPage'))
const TaxSettingPage = LazyRetry(
    () => import('components/Financials/Taxes/TaxSettingPage'),
)
const TaxProductPage = LazyRetry(
    () => import('pages/FinancialPage/Taxes/TaxProductPage'),
)
const EditCombinedTaxPage = LazyRetry(
    () => import('components/Financials/Taxes/EditCombinedTaxPage'),
)
const EditSingleTaxPage = LazyRetry(
    () => import('components/Financials/Taxes/EditSingleTaxPage'),
)
const NewTaxPage = LazyRetry(
    () => import('components/Financials/Taxes/NewTaxFormPage'),
)
const KDSIntegrations = LazyRetry(
    () => import('pages/DeviceIntegrationsPage/KDSIntegrations/KDSIntegration'),
)

const KDSIntegrationEdit = LazyRetry(
    () =>
        import(
            'pages/DeviceIntegrationsPage/KDSIntegrations/KDSIntegrationEdit'
        ),
)
const NotificationIntegrations = LazyRetry(
    () =>
        import(
            'pages/DeviceIntegrationsPage/NotificationIntegrations/NotificationIntegrations'
        ),
)
const NotificationIntegrationsEdit = LazyRetry(
    () =>
        import(
            'pages/DeviceIntegrationsPage/NotificationIntegrations/NotificationIntegrationsEdit'
        ),
)
const HardwareAgents = LazyRetry(
    () => import('pages/HardwareAgentPage/HardwareAgents/HardwareAgents'),
)
const Printer = LazyRetry(
    () => import('pages/PrinterDevicePage/Printer/Printer'),
)
const EditPaymentAccount = LazyRetry(
    () => import('components/Financials/Accounts/EditPaymentAccount'),
)
const Discounts = LazyRetry(
    () => import('components/DiscountsPromotions/Discounts/Discounts'),
)
const NewUpsertDiscounts = LazyRetry(
    () => import('pages/DiscountsPage/UpsertDiscountPage'),
)
const EditPriceList = LazyRetry(
    () => import('components/PriceLists/EditPriceList'),
)
const PriceLists = LazyRetry(() => import('components/PriceLists/PriceLists'))
const PosPayments = LazyRetry(
    () => import('pages/PaymentMethodPage/PosPayments/PosPayments'),
)
const SystemPayments = LazyRetry(
    () => import('pages/PaymentMethodPage/SystemPayments/SystemPayments'),
)
const EditGiftCardMain = LazyRetry(
    () => import('pages/GiftCardsPage/GiftCards/EditGiftCard/EditGiftCardMain'),
)
const GiftCardMain = LazyRetry(
    () => import('pages/GiftCardsPage/GiftCards/GiftCardMain'),
)
const GiftCardSettings = LazyRetry(
    () => import('pages/GiftCardsPage/GiftCardSettings/GiftCardSettings'),
)
const CustomerAdmin = LazyRetry(
    () => import('components/CustomerAdmin/CustomerAdmin'),
)
const CustomerCategoryAdmin = LazyRetry(
    () =>
        import(
            'components/CustomerAdmin/CustomerCategoryAdmin/CustomerCategories'
        ),
)
const EditCustomerCategory = LazyRetry(
    () =>
        import(
            'components/CustomerAdmin/CustomerCategoryAdmin/EditCustomerCategory'
        ),
)
const NewCustomer = LazyRetry(
    () => import('views/Customers/NewCustomer/NewCustomer'),
)
const EditCustomer = LazyRetry(
    () => import('views/Customers/NewCustomer/EditNewCustomer'),
)
const EventRouteSettings = LazyRetry(
    () => import('components/EventRouteSettings/EventRouteSetting'),
)
const EventRouteEditor = LazyRetry(
    () => import('components/EventRouteSettings/EventRouteSettingEdit'),
)
const LocationBrands = LazyRetry(
    () => import('components/OperationalSetting/Brands/LocationBrands'),
)
const ResetSalesPage = LazyRetry(
    () => import('pages/ResetSalesPage/ResetSalesPage'),
)
const GeneralSetting = LazyRetry(
    () => import('components/OperationalSetting/General/GeneralSetting'),
)
const UpsertCustomerFacingDisplaySettingPage = LazyRetry(
    () =>
        import(
            'pages/DeviceIntegrationsPage/CustomerFacingDisplaySetting/UpsertCustomerFacingDisplaySettingPage'
        ),
)

const CustomerFacingDisplaySettingPage = LazyRetry(
    () =>
        import(
            'pages/DeviceIntegrationsPage/CustomerFacingDisplaySetting/CustomerFacingDisplaySettingPage'
        ),
)
const OrderWireModules = LazyRetry(
    () =>
        import(
            'components/OperationalSetting/OrderWireModules/OrderWireModules'
        ),
)
const TimeClock = LazyRetry(
    () => import('pages/EmployeeTimeClockSettingPage/TimeClockPage'),
)
const NotificationGroupMain = LazyRetry(
    () =>
        import(
            'components/RolePermission/NotificationGroups/NotificationGroups'
        ),
)
const UpsertNotificationGroup = LazyRetry(
    () =>
        import(
            'components/RolePermission/NotificationGroups/UpsertNotificationGroup'
        ),
)
const RoleMain = LazyRetry(() => import('components/RolePermission/RoleMain'))
const UpsertRole = LazyRetry(
    () => import('components/RolePermission/UpsertRole/UpsertRole'),
)
const UserMain = LazyRetry(() => import('components/RolePermission/UserMain'))
const EditUser = LazyRetry(
    () => import('pages/UserPage/User/EditUser/EditUser'),
)
const OrderfulfillmentOption = LazyRetry(
    () =>
        import(
            'components/OperationalSetting/FulfillmentOptions/OrderfulfillmentOption'
        ),
)
const Brands = LazyRetry(
    () => import('components/Location-Setting/Brands/Brands'),
)
const UpsertBrands = LazyRetry(
    () => import('components/Location-Setting/Brands/upsertBrands'),
)
const CompanySubscription = LazyRetry(
    () =>
        import(
            'components/Location-Setting/CompanySubscription/CompanySubscription'
        ),
)
const MainUpdateCompany = LazyRetry(
    () => import('components/Location-Setting/UpsertCompany/MainUpdateCompany'),
)
const UpsertLocation = LazyRetry(
    () => import('components/Location-Setting/UpsertLocation/UpsertLocation'),
)
const ReceiptTemplates = LazyRetry(
    () => import('components/ReceiptAndReportSettings/ReceiptTemplates'),
)

const PosUpdatePayment = LazyRetry(
    () => import('pages/PaymentMethodPage/PosPayments/UpdatePayment'),
)
const CustomPaymentLookup = LazyRetry(
    () => import('pages/PaymentMethodPage/CustomPayments/CustomPayments'),
)
const CustomPaymentUpsert = LazyRetry(
    () => import('pages/PaymentMethodPage/CustomPayments/UpsertCustomPayment'),
)
const EmployeeReportPage = LazyRetry(
    () => import('pages/EmployeeReportPage/EmployeeReportPage'),
)
const EmployeeHoursMain = LazyRetry(
    () => import('pages/EmployeeReportPage/EmployeeHoursMain'),
)
const EmployeePerformance = LazyRetry(
    () => import('pages/BusinessReportPage/Employee/Component'),
)

const UserPreference = LazyRetry(() => import('pages/UserPreferencePage'))
const SystemSetting = LazyRetry(
    () => import('pages/OperationalSettingPage/OperationalSettingsPage'),
)
const Financial = LazyRetry(() => import('pages/FinancialPage/FinancialsPage'))

const CompanySetting = LazyRetry(() => import('pages/CompanySettingPage'))
const ProductsPage = LazyRetry(() => import('pages/ProductsPage/ProductsPage'))
const OnlineOrderPage = LazyRetry(() => import('pages/OnlineOrderPage'))
const OnlineOrder = LazyRetry(
    () => import('views/OnlineStore/OnlineOrders/OnlineOrder'),
)
const CloseOfDayReport = LazyRetry(
    () => import('pages/CloseOfDayReportPage/CloseOfDayReportPage'),
)
const TerminalPreference = LazyRetry(
    () => import('pages/terminalPreferencePage'),
)

const TerminalPrintingSetting = LazyRetry(
    () => import('components/TerminalPreference/Printing/Printing'),
)
const TerminalPaymentSetting = LazyRetry(
    () => import('components/TerminalPreference/Payment/Payment'),
)
const TerminalCustomerFacingDisplaySetting = LazyRetry(
    () =>
        import(
            'components/TerminalPreference/CustomerFacingDisplay/CustomerFacingDisplay'
        ),
)
const TotalSalesDashboardPage = LazyRetry(
    () => import('pages/DashboardPage/DashboardPage'),
)
const Dashboard = LazyRetry(() => import('pages/DashboardPage/Dashboard'))

const MyAccount = LazyRetry(() => import('pages/MyAccountPage'))
const ReportPage = LazyRetry(
    () => import('pages/ReportSettingPage/ReportSetting/ReportSetting'),
)
const CustomerLoyaltyPage = LazyRetry(
    () => import('pages/CustomerLoyaltyPage/CustomerLoyaltyPage'),
)

const PaymentDevicesPage = LazyRetry(
    () => import('pages/PaymentMethodPage/PaymentDevices/PaymentDevices'),
)

enum MenuNames {
    OperationMenu = 'OperationMenu',
    ReportMenu = 'ReportMenu',
    OnlineMenu = 'OnlineMenu',
    ProductSetupMenu = 'ProductSetupMenu',
    InventoryMenu = 'InventoryMenu',
    PosSettingMenu = 'PosSettingMenu',
    DeviceMenu = 'DeviceMenu',
    FinancialMenu = 'FinancialMenu',
    PromotionMenu = 'PromotionMenu',
    EmployeeMenu = 'EmployeeMenu',
    customerMenu = 'customerMenu',
    settingMenu = 'settingMenu',
}
type MainMenuNav = { [key in MenuNames]: IMenu }
const getMenus: (t: any) => MainMenuNav = (t: any) => {
    const OperationMenu: IMenu = {
        title: t('side_navigation.operations'),
        displayFirst: true,
        navs: {
            [AdminRouteName.orderDashboard]: {
                title: t('side_navigation.operational_dashboard'),
                icon: <DashboardIcon />,
                ...AuthRoute.orderDashboard,
                routes: [
                    {
                        label: 'dash board',
                        path: ROUTE.ORDER_DASHBOARD,
                        requirePermission:
                            AuthRoute?.orderDashboard?.requirePermission ?? [],
                        // exact: true,
                    },
                ],
            },
            [AdminRouteName.quickService]: {
                title: t('side_navigation.quick_service'),
                icon: <QuickServiceIcon />,
                ...AuthRoute.quickSale,
                routes: [
                    {
                        label: t('side_navigation.quick_service'),
                        path: ROUTE.QUICK_SERVICE,
                        requirePermission:
                            AuthRoute?.quickSale?.requirePermission ?? [],
                    },
                ],
            },
            [AdminRouteName.tableService]: {
                title: t('side_navigation.table_service'),
                icon: <TableServiceIcon />,
                ...AuthRoute.tableSales,
                routes: [
                    {
                        label: t('side_navigation.table_service'),
                        path: ROUTE.TABLE_SERVICE,
                        requirePermission:
                            AuthRoute?.tableSales?.requirePermission ?? [],
                    },
                ],
            },
            [AdminRouteName.onlineOrder]: {
                title: t('side_navigation.online_orders'),
                icon: <OnlineOrderIcon />,
                path: ROUTE.ONLINE_ORDERS,
                component: OnlineOrderPage,
                requirePermission: [SALES_ONLINE_ORDER],
                routes: [
                    {
                        label: t('side_navigation.online_orders'),
                        path: ROUTE.ONLINE_ORDERS_MY_ORDERS,
                        component: <OnlineOrder />,
                        requirePermission: [SALES_ONLINE_ORDER],
                        exact: true,
                    },
                ],
            },
        },
    }
    const ReportMenu: IMenu = {
        title: t('side_navigation.reports'),
        navs: {
            [AdminRouteName.totalSaleDashboard]: {
                title: t('side_navigation.dashboard'),
                icon: <DashboardIcon />,
                path: ROUTE.TOTAL_SALE_DASHBOARD,
                component: TotalSalesDashboardPage,
                requirePermission: [DASHBOARD_DASHBOARD_ADMIN],
                routes: [
                    {
                        label: t('dashboard.dashboard'),
                        path: ROUTE.TOTAL_SALE_DASHBOARD,
                        component: <Dashboard />,
                        exact: true,
                        requirePermission: [DASHBOARD_DASHBOARD_ADMIN],
                    },
                ],
            },
            [AdminRouteName.closeOfDay]: {
                title: t('side_navigation.z_close_day'),
                icon: <CloseOfDayIcon />,
                path: ROUTE.CLOSE_OF_DAY,
                redirectToPath: ROUTE.CLOSE_OF_DAY_PROCESS,
                component: CloseOfDayReport,
                requirePermission: [
                    REPORT_RUN_CLOSE_OF_DAY,
                    REPORT_CLOSURE_HISTORY,
                    SYSTEM_SETUP_CLOSEING_PROCEDURE,
                ],
                routes: [
                    {
                        label: t('close_of_day.tab.close_of_day'),
                        path: ROUTE.CLOSE_OF_DAY_PROCESS,
                        component: <CloseOfDayReportTab />,
                        exact: true,
                        requirePermission: [REPORT_RUN_CLOSE_OF_DAY],
                    },
                    {
                        label: t('close_of_day.tab.closure_history'),
                        path: ROUTE.CLOSE_OF_DAY_CLOSURE_HISTORY,
                        component: <CodClosureHistory />,
                        exact: true,
                        requirePermission: [REPORT_CLOSURE_HISTORY],
                    },
                    {
                        path: ROUTE.CLOSE_OF_DAY_PROCESS_SUMMARY,
                        component: <CloseOfDaySummary />,
                        requirePermission: [
                            REPORT_RUN_CLOSE_OF_DAY,
                            REPORT_CLOSURE_HISTORY,
                        ],
                    },
                    {
                        label: t('reports.tab_title.cod_setting'),
                        path: ROUTE.CLOSE_OF_DAY_CLOSING_PROCEDURE_SETTING,
                        component: <ClosingProcedure />,
                        requirePermission: [SYSTEM_SETUP_CLOSEING_PROCEDURE],
                    },
                ],
            },
            [AdminRouteName.salesReport]: {
                title: t('side_navigation.sales_reports'),
                icon: <ReportIcon />,
                path: ROUTE.SALES_REPORTS,
                component: BusinessReportPage,
                redirectToPath: ROUTE.SALES_REPORTS_MAIN,
                requirePermission: [REPORT_READ_DAILY_SALE],
                routes: [
                    {
                        label: t('business_report.sale.summary.shortName'),
                        path: ROUTE.SALES_SUMMARY_REPORTS,
                        component: <SalesSummaryReport />,
                        requirePermission: [REPORT_READ_DAILY_SALE],
                    },
                    {
                        label: t('business_report.sale.growth.shortName'),
                        path: ROUTE.SALES_GROWTH_REPORTS,
                        component: <SalesGrowthReport />,
                        requirePermission: [REPORT_READ_DAILY_SALE],
                    },
                    {
                        label: t('business_report.sale.discount.shortName'),
                        path: ROUTE.SALES_DISCOUNT_REPORTS,
                        component: <SalesDiscountReport />,
                        requirePermission: [REPORT_READ_DAILY_SALE],
                    },
                    {
                        label: t('business_report.sale.employee.shortName'),
                        path: ROUTE.SALES_EMPLOYEE_REPORTS,
                        component: <SalesEmployeeReport />,
                        requirePermission: [REPORT_READ_DAILY_SALE],
                    },
                    {
                        label: t('business_report.sale.category.shortName'),
                        path: ROUTE.SALES_CATEGORY_REPORTS,
                        component: <SalesCategoryReport />,
                        requirePermission: [REPORT_READ_DAILY_SALE],
                    },
                    {
                        label: t('business_report.sale.product.shortName'),
                        path: ROUTE.SALES_PRODUCT_REPORTS,
                        component: <SalesProductReport />,
                        requirePermission: [REPORT_READ_DAILY_SALE],
                    },
                ],
            },
            [AdminRouteName.terminalReport]: {
                title: t('side_navigation.terminals'),
                icon: <ReportIcon />,
                path: ROUTE.TERMINAL_REPORTS,
                component: TerminalReportPage,
                redirectToPath: ROUTE.TERMINAL_REPORTS_CLOSURE_HISTORY,
                requirePermission: [REPORT_CLOSURE_HISTORY_REPORT],
                routes: [
                    {
                        label: 'Closure History',
                        path: ROUTE.TERMINAL_REPORTS_CLOSURE_HISTORY,
                        component: <ClosureHistory />,
                        exact: true,
                        requirePermission: [REPORT_CLOSURE_HISTORY_REPORT],
                    },
                    {
                        path: ROUTE.TERMINAL_REPORTS_CLOSURE_HISTORY_REPORT,
                        component: <TerminalReportDetailPage />,
                        requirePermission: [REPORT_CLOSURE_HISTORY_REPORT],
                    },
                ],
            },
            [AdminRouteName.accountReport]: {
                title: t('side_navigation.accounting'),
                icon: <ReportIcon />,
                path: ROUTE.ACCOUNTING_REPORTS,
                component: AccountReportPage,
                redirectToPath: ROUTE.ACCOUNTING_REPORTS_MAIN,
                requirePermission: [REPORT_ACCOUNTING_JOURNAL],
                routes: [
                    {
                        label: 'Accounting',
                        path: ROUTE.ACCOUNTING_REPORTS_MAIN,
                        component: <AccountReportContainer />,
                        requirePermission: [REPORT_ACCOUNTING_JOURNAL],
                    },
                ],
            },
            [AdminRouteName.settingReport]: {
                title: 'report settings',
                icon: <SettingIcon />,
                path: ROUTE.REPORT_SETTINGS,
                component: ReportSettingPage,
                requirePermission: [REPORT_MANAGEMENT_MANAGE_REPORT],
                routes: [
                    {
                        label: t('reports.report_settings'),
                        path: ROUTE.REPORT_SETTINGS_MAIN,
                        component: <ReportPage />,
                        exact: true,
                        requirePermission: [REPORT_MANAGEMENT_MANAGE_REPORT],
                    },
                ],
            },
        },
    }
    const OnlineMenu: IMenu = {
        title: 'Online',
        navs: {
            [AdminRouteName.onlineStore]: {
                title: t('side_navigation.online_stores'),
                icon: <OnlineStoreIcon />,
                path: ROUTE.ONLINE_STORE,
                component: OnlineStorePage,
                redirectToPath: ROUTE.ONLINE_STORE_MY_STORES,
                requirePermission: [
                    ONLINE_STORE_MANAGEMENT_MANAGE_ONLINE_STORE,
                    ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT,
                ],
                routes: [
                    {
                        label: t('online_orders.label.online_stores'),
                        path: ROUTE.ONLINE_STORE_MY_STORES,
                        component: <OnlineStoresPage />,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_MANAGE_ONLINE_STORE,
                        ],
                        exact: true,
                    },
                    {
                        path: ROUTE.ONLINE_STORE_STORES_NEW,
                        component: <NewOnlineStore />,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_MANAGE_ONLINE_STORE,
                        ],
                        exact: true,
                    },
                    {
                        path: ROUTE.ONLINE_STORE_STORES_EDIT,
                        component: <EditOnlineStore />,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_MANAGE_ONLINE_STORE,
                        ],
                        exact: true,
                    },
                    {
                        label: t('online_store.label.order_channels'),
                        path: ROUTE.ONLINE_STORE_ORDER_CHANNEL,
                        component: <OnlineOrderChannelPage />,
                        exact: true,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT,
                        ],
                    },
                    {
                        path: ROUTE.ONLINE_STORE_ORDER_CHANNEL_NEW,
                        component: <NewOnlineOrderChannel />,
                        exact: true,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT,
                        ],
                    },
                    {
                        path: ROUTE.ONLINE_STORE_ORDER_CHANNEL_EDIT,
                        component: <EditOnlineOrderChannel />,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT,
                        ],
                    },
                ],
            },
            [AdminRouteName.onlineMenuBuilder]: {
                title: t('side_navigation.online_menu_builder'),
                icon: <OnlineMenuBuilderIcon />,
                path: ROUTE.ONLINE_MENU_BUILDER,
                requirePermission: [ONLINE_STORE_MANAGEMENT_MENU_MANAGEMENT],
                component: OnlineMenuBuilderPage,
                routes: [
                    {
                        label: 'ONLINE MENU BUILDER',
                        path: ROUTE.ONLINE_MENU_BUILDER_MAIN,
                        component: <OnlineMenuBuilderMainPage />,
                        exact: true,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_MENU_MANAGEMENT,
                        ],
                    },
                    {
                        path: ROUTE.ONLINE_MENU_BUILDER_NEW,
                        exact: true,
                        component: <UpsertMenuBuilder />,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_MENU_MANAGEMENT,
                        ],
                    },
                    {
                        path: ROUTE.ONLINE_MENU_BUILDER_EDIT,
                        exact: true,
                        component: <UpsertMenuBuilder />,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_MENU_MANAGEMENT,
                        ],
                    },
                ],
            },
            [AdminRouteName.onlineIntegrations]: {
                title: 'online integrations',
                icon: <IntegrationIcon />,
                path: ROUTE.ONLINE_INTEGRATIONS,
                component: OnlineIntegrationsPage,
                requirePermission: [
                    ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT,
                ],
                routes: [
                    {
                        label: t('integrations.label.online_integrations'),
                        path: ROUTE.ONLINE_INTEGRATIONS_MAIN,
                        exact: true,
                        component: <OnlineIntegrations />,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT,
                        ],
                    },
                    {
                        path: ROUTE.ONLINE_INTEGRATIONS_EDIT,
                        component: <OnlineIntegrationsEdit />,
                        requirePermission: [
                            ONLINE_STORE_MANAGEMENT_ORDER_CHANNEL_MANAGEMENT,
                        ],
                    },
                ],
            },
        },
    }
    const ProductSetupMenu: IMenu = {
        title: 'Products setup',
        displayFirst: true,
        navs: {
            [AdminRouteName.productCategory]: {
                title: 'Categories',
                icon: <CategoryIcon />,
                path: ROUTE.PRODUCT_CATEGORIES,
                component: CategoriesPage,
                requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                routes: [
                    {
                        label: t('products.products.label.sales_categories'),
                        path: ROUTE.PRODUCT_CATEGORIES_MAIN,
                        component: <Categories />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        path: ROUTE.PRODUCT_CATEGORIES_NEW,
                        component: <NewCategory />,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        path: ROUTE.PRODUCT_CATEGORIES_EDIT,
                        component: <EditCategory />,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                ],
            },
            [AdminRouteName.product]: {
                title: t('side_navigation.products'),
                icon: <ProductIcon />,
                path: ROUTE.PRODUCT,
                redirectToPath: ROUTE.PRODUCT_PRODUCTS,
                component: ProductsPage,
                requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                routes: [
                    {
                        label: t('products.products.label.products'),
                        path: ROUTE.PRODUCT_PRODUCTS,
                        component: <Product />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        path: ROUTE.PRODUCT_PRODUCTS_NEW,
                        component: <NewProduct />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        path: ROUTE.PRODUCT_PRODUCTS_EDIT,
                        component: <EditProductNew />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        label: t('products.products.label.variant_groups'),
                        path: ROUTE.PRODUCT_VARIANTS,
                        component: <Variants />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        path: ROUTE.PRODUCT_VARIANTS_NEW,
                        component: <UpsertVariant />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        path: ROUTE.PRODUCT_VARIANTS_EDIT,
                        component: <UpsertVariant />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        label: t('products.products.label.modifier_groups'),
                        path: ROUTE.PRODUCT_MODIFIER_GROUPS,
                        component: <ModifierGroups />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        path: ROUTE.PRODUCT_MODIFIER_GROUPS_NEW,
                        component: <UpsertModifierGroup />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        path: ROUTE.PRODUCT_MODIFIER_GROUPS_EDIT,
                        component: <UpsertModifierGroup />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                    },
                    {
                        label: t(
                            'products.products.label.deposit_and_credit_products',
                        ),
                        path: ROUTE.PRODUCT_DEPOSIT_AND_CREDIT_PRODUCT,
                        component: <DepositAndCreditProduct />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                        featureFlags: [FeatureFlag.DepositAndCredit],
                    },
                    {
                        path: ROUTE.PRODUCT_DEPOSIT_AND_CREDIT_PRODUCT_NEW,
                        component: <DepositAndCreditProductEdit />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                        featureFlags: [FeatureFlag.DepositAndCredit],
                    },
                    {
                        path: ROUTE.PRODUCT_DEPOSIT_AND_CREDIT_PRODUCT_EDIT,
                        component: <DepositAndCreditProductEdit />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_PRODUCT],
                        featureFlags: [FeatureFlag.DepositAndCredit],
                    },
                ],
            },
            [AdminRouteName.combo]: {
                title: 'combo set',
                icon: <ComboIcon />,
                path: ROUTE.PRODUCT_COMBOS,
                component: CombosPage,
                requirePermission: [PRODUCT_MANAGEMENT_COMBOS],
                routes: [
                    {
                        label: t('products.products.label.combos'),
                        path: ROUTE.PRODUCT_COMBOS_MAIN,
                        component: <Combos />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_COMBOS],
                    },
                    {
                        path: ROUTE.PRODUCT_COMBOS_NEW,
                        component: <NewComboSet />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_COMBOS],
                    },
                    {
                        path: ROUTE.PRODUCT_COMBOS_EDIT,
                        component: <NewComboSet />,
                        exact: true,
                        requirePermission: [PRODUCT_MANAGEMENT_COMBOS],
                    },
                ],
            },
            [AdminRouteName.ingredient]: {
                title: 'ingredients',
                icon: <IngredientsIcon />,
                path: ROUTE.PRODUCT_INGREDIENTS,
                requirePermission: [PRODUCT_MANAGEMENT_INGREDIENTS],
                component: IngredientsPage,
                routes: [
                    {
                        label: t('products.products.label.ingredients'),
                        path: ROUTE.PRODUCT_INGREDIENTS_MAIN,
                        exact: true,
                        component: <Ingredients />,
                        requirePermission: [PRODUCT_MANAGEMENT_INGREDIENTS],
                    },
                    {
                        path: ROUTE.PRODUCT_INGREDIENTS_NEW,
                        exact: true,
                        component: <NewIngredient />,
                        requirePermission: [PRODUCT_MANAGEMENT_INGREDIENTS],
                    },
                    {
                        path: ROUTE.PRODUCT_INGREDIENTS_EDIT,
                        component: <EditIngredient />,
                        requirePermission: [PRODUCT_MANAGEMENT_INGREDIENTS],
                    },
                ],
            },
            [AdminRouteName.vendor]: {
                title: t('side_navigation.vendors'),
                icon: <VendorsIcon />,
                path: ROUTE.VENDOR,
                redirectToPath: ROUTE.VENDOR_PROFILE,
                requirePermission: [VENDOR_MANAGEMENT_MANAGE_VENDOR],
                component: VendorsPage,
                routes: [
                    {
                        label: 'Vendors',
                        path: ROUTE.VENDOR_PROFILE,
                        component: <Vendors />,
                        exact: true,
                        requirePermission: [VENDOR_MANAGEMENT_MANAGE_VENDOR],
                    },
                    {
                        path: ROUTE.VENDOR_PROFILE_NEW,
                        component: <NewVendor />,
                        requirePermission: [VENDOR_MANAGEMENT_MANAGE_VENDOR],
                    },
                    {
                        path: ROUTE.VENDOR_PROFILE_EDIT,
                        component: <EditVendor />,
                        requirePermission: [VENDOR_MANAGEMENT_MANAGE_VENDOR],
                    },
                ],
            },
        },
    }
    const InventoryMenu: IMenu = {
        title: 'Inventory',
        navs: {
            [AdminRouteName.inventory]: {
                title: t('side_navigation.inventory'),
                icon: <InventoryIcon />,
                path: ROUTE.INVENTORY,
                requirePermission: [INVENTORY_MANAGEMENT_MANAGE_INVENTORY],
                component: InventoryLookupPage,
                routes: [
                    {
                        label: 'Item Inventory',
                        path: ROUTE.INVENTORY_ITEM,
                        component: <InventoryLookupTab />,
                        exact: true,
                        requirePermission: [
                            INVENTORY_MANAGEMENT_MANAGE_INVENTORY,
                        ],
                    },
                    {
                        label: 'Gift Card Inventory',
                        path: ROUTE.INVENTORY_GIFTCARD,
                        component: <GiftCardInventory />,
                        exact: true,
                        requirePermission: [
                            INVENTORY_MANAGEMENT_MANAGE_INVENTORY,
                        ],
                    },
                    {
                        path: ROUTE.INVENTORY_EDIT,
                        component: <InventoryAdjustmentForm />,
                        requirePermission: [
                            INVENTORY_MANAGEMENT_MANAGE_INVENTORY,
                        ],
                    },
                ],
            },
            [AdminRouteName.inventoryReport]: {
                title: t('side_navigation.inventory_reports'),
                icon: <ReportIcon />,
                path: ROUTE.INVENTORY_REPORT,
                redirectToPath: ROUTE.INVENTORY_REPORT_HISTORY,
                component: InventoryReportPage,
                requirePermission: [
                    REPORT_INVENTORY_REPORT,
                    REPORT_INVENTORY_REPORT_COGS,
                ],
                routes: [
                    {
                        label: 'Inventory History',
                        path: ROUTE.INVENTORY_REPORT_HISTORY,
                        component: <InventoryHistoryTab />,
                        exact: true,
                        requirePermission: [REPORT_INVENTORY_REPORT],
                    },
                    {
                        label: 'COGS Report',
                        path: ROUTE.INVENTORY_REPORT_COGS,
                        component: <CogsReportTab />,
                        exact: true,
                        requirePermission: [REPORT_INVENTORY_REPORT_COGS],
                    },
                ],
            },
            [AdminRouteName.uoms]: {
                title: t('side_navigation.uoms'),
                icon: <UOMIcon />,
                path: ROUTE.UOM,
                redirectToPath: ROUTE.UOM_UOMS,
                component: UOMsPage,
                requirePermission: [INVENTORY_MANAGEMENT_MANAGE_INVENTORY],
                featureFlags: [FeatureFlag.CustomUOM],
                routes: [
                    {
                        label: 'UOMs',
                        path: ROUTE.UOM_UOMS,
                        component: <UOMsLookup />,
                        exact: true,
                        requirePermission: [
                            INVENTORY_MANAGEMENT_MANAGE_INVENTORY,
                        ],
                    },
                    {
                        label: 'UOM Categories',
                        path: ROUTE.uom_categories,
                        exact: true,
                        component: <UOMClassesLookup />,
                        requirePermission: [
                            INVENTORY_MANAGEMENT_MANAGE_INVENTORY,
                        ],
                    },
                    {
                        path: ROUTE.UOM_NEW,
                        component: <NewUOM />,
                        exact: true,
                        requirePermission: [
                            INVENTORY_MANAGEMENT_MANAGE_INVENTORY,
                        ],
                    },
                    {
                        path: ROUTE.UOM_EDIT,
                        component: <EditUOM />,
                        exact: true,
                        requirePermission: [
                            INVENTORY_MANAGEMENT_MANAGE_INVENTORY,
                        ],
                    },
                ],
            },
        },
    }
    const PosSettingMenu: IMenu = {
        title: 'POS Settings',
        navs: {
            [AdminRouteName.posGeneral]: {
                title: t('side_navigation.pos'),
                icon: <SettingIcon />,
                path: ROUTE.POS_SETTINGS,
                redirectToPath: ROUTE.POS_SETTINGS_GENERAL,
                requirePermission: [POS_SETUP_GENERAL],
                component: PosPage,
                routes: [
                    {
                        label: t('pos.tabs.general'),
                        path: ROUTE.POS_SETTINGS_GENERAL,
                        component: <General />,
                        exact: true,
                        requirePermission: [POS_SETUP_GENERAL],
                    },
                    {
                        label: 'Service Charge',
                        path: ROUTE.POS_SETTINGS_SERVICE_CHARGE,
                        component: <ServiceChargeSettingProvider />,
                        exact: true,
                        requirePermission: [POS_SETUP_GENERAL],
                    },
                    {
                        label: 'Tips Settings',
                        path: ROUTE.POS_SETTINGS_TIPS_SETTINGS,
                        component: <TipsSettings />,
                        exact: true,
                        requirePermission: [POS_SETUP_GENERAL],
                    },
                ],
            },
            [AdminRouteName.posMenu]: {
                title: 'pos menus',
                icon: <POSMenuIcon />,
                path: ROUTE.POS_MENUS,
                redirectToPath: ROUTE.POS_MENUS_MENUS,
                component: MenuPage,
                requirePermission: [
                    POS_SETUP_MANAGE_MENUS,
                    POS_SETUP_MANAGE_MENU_VIEWS,
                ],
                routes: [
                    {
                        label: 'Menus',
                        path: ROUTE.POS_MENUS_MENUS,
                        component: <Menus />,
                        exact: true,
                        requirePermission: [POS_SETUP_MANAGE_MENUS],
                    },
                    {
                        label: 'Menu view',
                        path: ROUTE.POS_MENUS_MENUS_VIEW,
                        component: <MenuView />,
                        exact: true,
                        requirePermission: [POS_SETUP_MANAGE_MENU_VIEWS],
                    },
                    {
                        path: ROUTE.POS_MENUS_MENUS_NEW + '/old',
                        component: <UpsertMenuPage />,
                        requirePermission: [POS_SETUP_MANAGE_MENUS],
                    },
                    {
                        path: ROUTE.POS_MENUS_MENUS_EDIT + '/old',
                        component: <UpsertMenuPage />,
                        requirePermission: [POS_SETUP_MANAGE_MENUS],
                    },
                    {
                        path: ROUTE.POS_MENUS_MENUS_NEW,
                        component: <UpsertMenuPageNewer />,
                        requirePermission: [POS_SETUP_MANAGE_MENUS],
                    },
                    {
                        path: ROUTE.POS_MENUS_MENUS_EDIT,
                        component: <UpsertMenuPageNewer />,
                        requirePermission: [POS_SETUP_MANAGE_MENUS],
                    },
                ],
            },
            [AdminRouteName.posSaleProcessing]: {
                title: 'POS Sales Processing',
                icon: <POSSaleProcessingIcon />,
                path: ROUTE.POS_SALES_PROCESSING,
                redirectToPath: ROUTE.POS_SALES_PROCESSING_GENERAL,
                requirePermission: [POS_SETUP_MANAGE_SALES_PROCESSING],
                component: PosSaleProcessingPage,
                routes: [
                    {
                        label: 'General Sales Rules',
                        path: ROUTE.POS_SALES_PROCESSING_GENERAL,
                        component: <GeneralSaleRuleSetting />,
                        exact: true,
                        requirePermission: [POS_SETUP_MANAGE_SALES_PROCESSING],
                    },
                    {
                        label: 'Quick Service Rules',
                        path: ROUTE.POS_SALES_PROCESSING_QS,
                        component: <QuickServiceRuleSetting />,
                        exact: true,
                        requirePermission: [POS_SETUP_MANAGE_SALES_PROCESSING],
                    },
                    {
                        label: 'Table Service Rules',
                        path: ROUTE.POS_SALES_PROCESSING_TS,
                        component: <TableServiceRuleSetting />,
                        exact: true,
                        requirePermission: [POS_SETUP_MANAGE_SALES_PROCESSING],
                    },
                    {
                        label: 'Online Order Rules',
                        path: ROUTE.POS_SALES_PROCESSING_ONLINE,
                        component: <OnlineOrderRuleSetting />,
                        exact: true,
                        requirePermission: [POS_SETUP_MANAGE_SALES_PROCESSING],
                    },
                ],
            },
            [AdminRouteName.posCondition]: {
                title: 'POS conditions',
                icon: <POSContitionsIcon />,
                path: ROUTE.POS_CONDITIONS,
                redirectToPath: ROUTE.POS_CONDITIONS_ORDER_NUMBERING,
                component: PosConditionPage,
                requirePermission: [
                    POS_SETUP_MANAGE_VOID_COMP_REASONS,
                    POS_SETUP_MANAGE_PAY_IN_OUT_REASONS,
                    SYSTEM_SETUP_ORDER_NUMBER,
                ],
                routes: [
                    {
                        exact: true,
                        component: <OrderNumberingSetting />,
                        label: 'Order Numbering',
                        path: `${ROUTE.POS_CONDITIONS_ORDER_NUMBERING}`,
                        requirePermission: [SYSTEM_SETUP_ORDER_NUMBER],
                    },
                    {
                        label: t('pos.tabs.void_comp_reasons'),
                        path: ROUTE.POS_CONDITIONS_VOID_COMP_REASONS,
                        component: <VoidCompsReasons />,
                        exact: true,
                        requirePermission: [POS_SETUP_MANAGE_VOID_COMP_REASONS],
                    },
                    {
                        path: ROUTE.POS_CONDITIONS_VOID_COMP_REASONS_NEW,
                        component: <VoidCompsReasonEdit />,
                        requirePermission: [POS_SETUP_MANAGE_VOID_COMP_REASONS],
                    },
                    {
                        path: ROUTE.POS_CONDITIONS_VOID_COMP_REASONS_EDIT,
                        component: <VoidCompsReasonEdit />,
                        requirePermission: [POS_SETUP_MANAGE_VOID_COMP_REASONS],
                    },
                    {
                        label: t('pos.tabs.payin_payout_reasons'),
                        path: ROUTE.POS_CONDITIONS_PAYINPAYOUTREASONS,
                        component: <PayInPayOutReasons />,
                        requirePermission: [
                            POS_SETUP_MANAGE_PAY_IN_OUT_REASONS,
                        ],
                        exact: true,
                    },
                    {
                        path: ROUTE.POS_CONDITIONS_PAYINPAYOUTREASONS_NEW,
                        component: <NewPayInPayOutReason />,
                        requirePermission: [
                            POS_SETUP_MANAGE_PAY_IN_OUT_REASONS,
                        ],
                    },
                    {
                        path: ROUTE.POS_CONDITIONS_PAYINPAYOUTREASONS_EDIT,
                        component: <EditPayInPayOutReason />,
                        requirePermission: [
                            POS_SETUP_MANAGE_PAY_IN_OUT_REASONS,
                        ],
                    },
                ],
            },
            [AdminRouteName.tableLayout]: {
                title: 'table layouts',
                icon: <TableServiceIcon />,
                path: ROUTE.POS_TABLE_LAYOUTS,
                component: TableLayoutPage,
                requirePermission: [POS_SETUP_MANAGE_TABLE_LAYOUT],
                routes: [
                    {
                        label: t('pos.tabs.table_layouts'),
                        component: <TableLayout />,
                        exact: true,
                        path: ROUTE.POS_TABLE_LAYOUTS_MAIN,
                        requirePermission: [POS_SETUP_MANAGE_TABLE_LAYOUT],
                    },
                    {
                        component: <EditTableLayout />,
                        exact: true,
                        path: ROUTE.POS_TABLE_LAYOUTS_NEW,
                        requirePermission: [POS_SETUP_MANAGE_TABLE_LAYOUT],
                    },
                    {
                        component: <EditTableLayout />,
                        path: ROUTE.POS_TABLE_LAYOUTS_EDIT,
                        requirePermission: [POS_SETUP_MANAGE_TABLE_LAYOUT],
                    },
                ],
            },
            [AdminRouteName.receiptSetting]: {
                title: t('side_navigation.receipt_and_report_settings'),
                icon: <ReceiptSettingIcon />,
                path: ROUTE.RECEIPT_SETTINGS,
                redirectToPath: ROUTE.RECEIPT_SETTINGS_TEMPLATES,
                component: ReceiptSettingsPage,
                requirePermission: [
                    RECEIPT_AND_REPORT_MANAGEMENT_MANAGE_RECEIPT,
                ],
                routes: [
                    {
                        label: 'Receipt Templates',
                        path: ROUTE.RECEIPT_SETTINGS_TEMPLATES,
                        component: <ReceiptTemplates />,
                        exact: true,
                        requirePermission: [
                            RECEIPT_AND_REPORT_MANAGEMENT_MANAGE_RECEIPT,
                        ],
                    },
                    {
                        path: ROUTE.RECEIPT_SETTINGS_TEMPLATES_EDIT,
                        component: <EditReceipt />,
                        requirePermission: [
                            RECEIPT_AND_REPORT_MANAGEMENT_MANAGE_RECEIPT,
                        ],
                    },
                ],
            },
        },
    }
    const DeviceMenu: IMenu = {
        title: 'Device and integrations',
        navs: {
            [AdminRouteName.terminalDevice]: {
                title: 'terminal devices',
                icon: <TerminalIcon />,
                path: ROUTE.DEVICE_TERMINAL,
                redirectToPath: ROUTE.DEVICE_TERMINAL_POS,
                requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                component: TerminalDevicePage,
                routes: [
                    {
                        label: 'POS Terminals',
                        path: ROUTE.DEVICE_TERMINAL_POS,
                        exact: true,
                        component: <PosTerminalDevices />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                    {
                        path: ROUTE.DEVICE_TERMINAL_POS_NEW,
                        component: <UpsertPosTerminalDevicePage />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                    {
                        path: ROUTE.DEVICE_TERMINAL_POS_EDIT,
                        component: <UpsertPosTerminalDevicePage />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                    {
                        label: 'Terminal Connectivity',
                        path: ROUTE.DEVICE_TERMINAL_POS_VIEW_CONNECTIVITY,
                        component: <PosTerminalConnectivity />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                ],
            },
            [AdminRouteName.printerDevice]: {
                title: 'printers',
                icon: <PrinterIcon />,
                path: ROUTE.DEVICE_PRINTERS,
                requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                component: PrinterDevicePage,
                routes: [
                    {
                        label: 'Printers',
                        path: ROUTE.DEVICE_PRINTERS_MAIN,
                        exact: true,
                        component: <Printer />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                ],
            },
            [AdminRouteName.hardwareAgents]: {
                title: ' hardware agents',
                icon: <HardwareAgentsIcon />,
                component: HardwareAgentPage,
                path: ROUTE.DEVICE_HARDWARE_AGENTS,
                requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                routes: [
                    {
                        label: 'Hardware agents',
                        path: ROUTE.DEVICE_HARDWARE_AGENTS_MAIN,
                        component: <HardwareAgents />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                ],
            },
            [AdminRouteName.integrationDevice]: {
                title: 'device integrations',
                icon: <IntegrationIcon />,
                path: ROUTE.DEVICE_INTEGRATIONS,
                redirectToPath: ROUTE.DEVICE_INTEGRATIONS_NOTIFICATIONS,
                requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                component: DeviceIntegrationsPage,
                routes: [
                    {
                        label: t(
                            'integrations.label.notification_integrations',
                        ),
                        path: ROUTE.DEVICE_INTEGRATIONS_NOTIFICATIONS,
                        exact: true,
                        component: <NotificationIntegrations />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                    {
                        path: ROUTE.DEVICE_INTEGRATIONS_NOTIFICATIONS_EDIT,
                        component: <NotificationIntegrationsEdit />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                    {
                        label: t('integrations.label.kds_integrations'),
                        path: ROUTE.DEVICE_INTEGRATIONS_KDS_INTEGRATIONS,
                        exact: true,
                        component: <KDSIntegrations />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                    {
                        path: ROUTE.DEVICE_INTEGRATIONS_KDS_INTEGRATIONS_EDIT,
                        component: <KDSIntegrationEdit />,
                        requirePermission: [SYSTEM_SETUP_DEVICE_MANAGEMENT],
                    },
                    {
                        label: 'Customer Facing Display',
                        moduleName: 'customerFacingDisplay',
                        component: <CustomerFacingDisplaySettingPage />,
                        exact: true,
                        path: `${ROUTE.DEVICE_INTEGRATIONS_CUSTOMER_FACING_DISPLAYS}`,
                        requirePermission: [],
                    },
                    {
                        moduleName: 'customerFacingDisplay',
                        component: <UpsertCustomerFacingDisplaySettingPage />,
                        path: `${ROUTE.DEVICE_INTEGRATIONS_CUSTOMER_FACING_DISPLAY_NEW}`,
                        requirePermission: [],
                    },
                    {
                        moduleName: 'customerFacingDisplay',
                        component: <UpsertCustomerFacingDisplaySettingPage />,
                        path: `${ROUTE.DEVICE_INTEGRATIONS_CUSTOMER_FACING_DISPLAY_EDIT}`,
                        requirePermission: [],
                    },
                ],
            },
        },
    }
    const FinancialMenu: IMenu = {
        title: 'Financials',
        navs: {
            [AdminRouteName.financialGeneral]: {
                title: t('side_navigation.financials'),
                icon: <SettingIcon />,
                path: ROUTE.FINANCIAL,
                redirectToPath: ROUTE.FINANCIAL_GENERAL,
                component: Financial,
                requirePermission: [
                    FINANCIAL_MANAGEMENT_GENERAL,
                    FINANCIAL_MANAGEMENT_COMPANY_DETAILS,
                    FINANCIAL_MANAGEMENT_GLCODES_MANAGEMENT,
                    FINANCIAL_MANAGEMENT_PAYMENT_ACCOUNT,
                ],
                routes: [
                    {
                        label: t('financials.title.general'),
                        path: ROUTE.FINANCIAL_GENERAL,
                        component: <FinancialGeneral />,
                        exact: true,
                        requirePermission: [FINANCIAL_MANAGEMENT_GENERAL],
                    },
                    {
                        label: t('financials.title.company_detail'),
                        path: ROUTE.FINANCIAL_COMPANY_DETAIL,
                        component: <CompanyDetail />,
                        exact: true,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_COMPANY_DETAILS,
                        ],
                    },

                    {
                        label: t('financials.title.accounting_codes'),
                        path: ROUTE.FINANCIAL_ACCOUNTING_CODES,
                        component: <AccountingCodes />,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_GLCODES_MANAGEMENT,
                        ],
                    },
                    {
                        label: t('financials.title.payment_accounts'),
                        path: ROUTE.FINANCIAL_PAYMENT_ACCOUNTS,
                        component: <PaymentAccounts />,
                        exact: true,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_PAYMENT_ACCOUNT,
                        ],
                    },
                    {
                        path: ROUTE.FINANCIAL_PAYMENT_ACCOUNTS_NEW,
                        component: <EditPaymentAccount />,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_PAYMENT_ACCOUNT,
                        ],
                    },
                    {
                        path: ROUTE.FINANCIAL_PAYMENT_ACCOUNTS_EDIT,
                        component: <EditPaymentAccount />,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_PAYMENT_ACCOUNT,
                        ],
                    },
                ],
            },
            [AdminRouteName.paymentMethod]: {
                title: 'payment methods',
                icon: <PaymentIcon />,
                path: ROUTE.PAYMENT_METHODS,
                redirectToPath: ROUTE.PAYMENT_METHODS_SYSTEM_PAYMENTS,
                component: PaymentMethodPage,
                requirePermission: [
                    FINANCIAL_MANAGEMENT_PAYMENT_METHOD,
                    POS_SETUP_MANAGE_PAYMENT,
                    SYSTEM_SETUP_INTEGRATIONS_PAYMENT,
                ],
                routes: [
                    {
                        label: 'system payment methods',
                        path: ROUTE.PAYMENT_METHODS_SYSTEM_PAYMENTS,
                        component: <SystemPayments />,
                        exact: true,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_PAYMENT_METHOD,
                        ],
                    },
                    {
                        label: 'Custom payment methods',
                        path: ROUTE.PAYMENT_METHODS_CUSTOM_PAYMENTS,
                        exact: true,
                        component: <CustomPaymentLookup />,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_PAYMENT_METHOD,
                        ],
                    },

                    {
                        path: ROUTE.PAYMENT_METHODS_CUSTOM_PAYMENTS_NEW,
                        exact: true,
                        component: <CustomPaymentUpsert />,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_PAYMENT_METHOD,
                        ],
                    },
                    {
                        path: ROUTE.PAYMENT_METHODS_CUSTOM_PAYMENTS_EDIT,
                        component: <CustomPaymentUpsert />,
                        exact: true,
                        requirePermission: [
                            FINANCIAL_MANAGEMENT_PAYMENT_METHOD,
                        ],
                    },
                    {
                        label: 'Pos payment methods',
                        path: ROUTE.PAYMENT_METHODS_POS_PAYMENTS,
                        component: <PosPayments />,
                        exact: true,
                        requirePermission: [POS_SETUP_MANAGE_PAYMENT],
                    },
                    {
                        path: ROUTE.PAYMENT_METHODS_POS_PAYMENTS_EDIT,
                        component: <PosUpdatePayment />,
                        requirePermission: [POS_SETUP_MANAGE_PAYMENT],
                    },
                    {
                        label: 'Payment Devices',
                        path: ROUTE.PAYMENT_METHODS_PAYMENT_DEVICES,
                        requirePermission: [
                            SYSTEM_SETUP_INTEGRATIONS_PAYMENT,
                            POS_SETUP_MANAGE_PAYMENT,
                        ],
                        exact: true,
                        component: <PaymentDevicesPage />,
                    },
                ],
            },
            [AdminRouteName.taxes]: {
                title: t('side_navigation.taxes'),
                icon: <FeedIcon />,
                path: ROUTE.FINANCIAL_TAXES,
                redirectToPath: ROUTE.FINANCIAL_TAXES_PRODUCT_TAXES,
                component: Taxes,
                requirePermission: [
                    FINANCIAL_MANAGEMENT_TAXES,
                    PRODUCT_MANAGEMENT_PRODUCT,
                    PRODUCT_MANAGEMENT_COMBOS,
                ],
                routes: [
                    {
                        label: 'Product Tax',
                        path: ROUTE.FINANCIAL_TAXES_PRODUCT_TAXES,
                        component: <TaxProductPage />,
                        exact: true,
                        requirePermission: [
                            PRODUCT_MANAGEMENT_PRODUCT,
                            PRODUCT_MANAGEMENT_COMBOS,
                        ],
                    },
                    {
                        label: t('financials.title.taxes'),
                        path: ROUTE.FINANCIAL_TAXES_SETTING,
                        component: <TaxSettingPage />,
                        exact: true,
                        requirePermission: [FINANCIAL_MANAGEMENT_TAXES],
                    },
                    {
                        path: ROUTE.FINANCIAL_TAXES_SETTING_NEW,
                        component: <NewTaxPage />,
                        requirePermission: [FINANCIAL_MANAGEMENT_TAXES],
                    },
                    {
                        path: ROUTE.FINANCIAL_TAXES_SETTING_SINGLE_TAX_EDIT,
                        component: <EditSingleTaxPage />,
                        requirePermission: [FINANCIAL_MANAGEMENT_TAXES],
                    },
                    {
                        path: ROUTE.FINANCIAL_TAXES_SETTING_COMBINED_TAX_EDIT,
                        component: <EditCombinedTaxPage />,
                        requirePermission: [FINANCIAL_MANAGEMENT_TAXES],
                    },
                ],
            },
            [AdminRouteName.priceList]: {
                title: t('side_navigation.price_lists'),
                icon: <PriceListIcon />,
                path: ROUTE.PRICE_LISTS,
                requirePermission: [PRICE_LIST_MANAGEMENT_MANAGE_PRICE_LIST],
                component: PriceListPage,
                routes: [
                    {
                        label: t('price_lists.label.price_lists_title'),
                        path: ROUTE.PRICE_LISTS_MAIN,
                        component: <PriceLists />,
                        exact: true,
                        requirePermission: [
                            PRICE_LIST_MANAGEMENT_MANAGE_PRICE_LIST,
                        ],
                    },
                    {
                        path: ROUTE.PRICE_LISTS_NEW,
                        component: <EditPriceList mode="New" />,
                        exact: true,
                        requirePermission: [
                            PRICE_LIST_MANAGEMENT_MANAGE_PRICE_LIST,
                        ],
                    },
                    {
                        path: ROUTE.PRICE_LISTS_EDIT,
                        component: <EditPriceList mode="Edit" />,
                        exact: true,
                        requirePermission: [
                            PRICE_LIST_MANAGEMENT_MANAGE_PRICE_LIST,
                        ],
                    },
                ],
            },
        },
    }
    const PromotionMenu: IMenu = {
        title: 'Promotions',
        navs: {
            [AdminRouteName.discount]: {
                title: t('side_navigation.discount_specials_and_promotions'),
                icon: <DiscountIcon />,
                path: ROUTE.DISCOUNTS_SPECIALS_PROMOTIONS,
                redirectToPath: ROUTE.DISCOUNTS,
                requirePermission: [DISCOUNT_DISCOUNT_MANAGEMENT],
                component: DiscountPage,
                routes: [
                    {
                        label: t('discounts.label.discounts'),
                        path: ROUTE.DISCOUNTS,
                        component: <Discounts />,
                        exact: true,
                        requirePermission: [DISCOUNT_DISCOUNT_MANAGEMENT],
                    },
                    {
                        path: ROUTE.DISCOUNTS_NEW,
                        component: <NewUpsertDiscounts />,
                        exact: true,
                        requirePermission: [DISCOUNT_DISCOUNT_MANAGEMENT],
                    },
                    {
                        path: ROUTE.DISCOUNTS_EDIT,
                        component: <NewUpsertDiscounts />,
                        exact: true,
                        requirePermission: [DISCOUNT_DISCOUNT_MANAGEMENT],
                    },
                ],
            },
            [AdminRouteName.giftCard]: {
                title: 'GiftCard',
                icon: <GiftCardIcon />,
                path: ROUTE.GIFTCARDS,
                component: GiftCardsPage,
                moduleName: OPERATIONAL_SETTING.giftCard,
                redirectToPath: ROUTE.GIFTCARDS_GIFTCARDS,
                requirePermission: [
                    PRODUCT_MANAGEMENT_ISSUE_GIFT_CARD,
                    PRODUCT_MANAGEMENT_MANIPULATE_GIFT_CARD,
                    SYSTEM_SETUP_GIFT_CARD,
                ],
                routes: [
                    {
                        label: t('products.gift_card.gift_cards'),
                        path: ROUTE.GIFTCARDS_GIFTCARDS,
                        component: <GiftCardMain />,
                        exact: true,
                        requirePermission: [
                            PRODUCT_MANAGEMENT_MANIPULATE_GIFT_CARD,
                            PRODUCT_MANAGEMENT_ISSUE_GIFT_CARD,
                        ],
                    },
                    {
                        label: 'Gift card settings',
                        exact: false,
                        component: <GiftCardSettings />,
                        path: `${ROUTE.GIFTCARDS_GIFTCARDS_SETTIGS}`,
                        requirePermission: [SYSTEM_SETUP_GIFT_CARD],
                    },
                    {
                        path: ROUTE.GIFTCARDS_GIFTCARDS_NEW,
                        component: <EditGiftCardMain />,
                        requirePermission: [
                            PRODUCT_MANAGEMENT_MANIPULATE_GIFT_CARD,
                            PRODUCT_MANAGEMENT_ISSUE_GIFT_CARD,
                        ],
                    },
                    {
                        path: ROUTE.GIFTCARDS_GIFTCARDS_EDIT,
                        component: <EditGiftCardMain />,
                        requirePermission: [
                            PRODUCT_MANAGEMENT_MANIPULATE_GIFT_CARD,
                            PRODUCT_MANAGEMENT_ISSUE_GIFT_CARD,
                        ],
                    },
                ],
            },
        },
    }
    const EmployeeMenu: IMenu = {
        title: 'Employees',
        navs: {
            [AdminRouteName.users]: {
                title: t('side_navigation.users'),
                icon: <UserIcon />,
                component: UserPage,
                path: ROUTE.USERS,
                redirectToPath: ROUTE.USERS_USERS,
                requirePermission: [
                    ...USER_ALL,
                    ...ROLE_ALL,
                    USERS_NOTIFICATION_GROUPS,
                ],
                routes: [
                    {
                        label: 'Users',
                        path: ROUTE.USERS_USERS,
                        component: <UserMain />,
                        exact: true,
                        requirePermission: USER_ALL,
                    },
                    {
                        path: ROUTE.USERS_USERS_NEW,
                        component: <EditUser />,
                        requirePermission: USER_ALL,
                    },
                    {
                        path: ROUTE.USERS_USERS_EDIT,
                        component: <EditUser />,
                        requirePermission: USER_ALL,
                    },
                    {
                        label: 'Roles',
                        path: ROUTE.USERS_ROLES,
                        component: <RoleMain />,
                        exact: true,
                        requirePermission: ROLE_ALL,
                    },
                    {
                        path: ROUTE.USERS_ROLES_NEW,
                        component: <UpsertRole />,
                        requirePermission: ROLE_ALL,
                    },
                    {
                        path: ROUTE.USERS_ROLES_EDIT,
                        component: <UpsertRole />,
                        requirePermission: ROLE_ALL,
                    },
                    {
                        label: 'Notification Groups',
                        path: ROUTE.USERS_NOTIFICATIONGROUP,
                        component: <NotificationGroupMain />,
                        exact: true,
                        requirePermission: [USERS_NOTIFICATION_GROUPS],
                    },
                    {
                        path: ROUTE.USERS_NOTIFICATIONGROUP_NEW,
                        component: <UpsertNotificationGroup />,
                        requirePermission: [USERS_NOTIFICATION_GROUPS],
                    },
                    {
                        path: ROUTE.USERS_NOTIFICATIONGROUP_EDIT,
                        component: <UpsertNotificationGroup />,
                        requirePermission: [USERS_NOTIFICATION_GROUPS],
                    },
                ],
            },
            [AdminRouteName.employeeTimeClock]: {
                title: 'Employee TimeClock',
                icon: <TimeClockIcon />,
                path: ROUTE.EMPLOYEE_TIME_CLOCK,
                redirectToPath: ROUTE.EMPLOYEE_TIME_CLOCK_SETTING,
                component: TimeClockSettingPage,
                moduleName: OPERATIONAL_SETTING.timeClock,
                requirePermission: [SYSTEM_SETUP_TIME_CLOCK],
                routes: [
                    {
                        exact: true,
                        component: <TimeClock />,
                        label: 'Time Clock Settings',
                        path: ROUTE.EMPLOYEE_TIME_CLOCK_SETTING,
                        requirePermission: [SYSTEM_SETUP_TIME_CLOCK],
                    },
                ],
            },
            [AdminRouteName.employeeReport]: {
                title: t('side_navigation.employees'),
                icon: <ReportIcon />,
                path: ROUTE.EMPLOYEE_REPORT,
                component: EmployeeReportPage,
                moduleName: OPERATIONAL_SETTING.timeClock,
                redirectToPath: ROUTE.EMPLOYEE_REPORT_TOTAL_HOURS,
                requirePermission: [REPORT_EMPLOYEE_REPORT],
                routes: [
                    {
                        label: 'Employee Hours',
                        path: ROUTE.EMPLOYEE_REPORT_TOTAL_HOURS,
                        component: <EmployeeHoursMain />,
                        requirePermission: [REPORT_EMPLOYEE_REPORT],
                    },
                    {
                        label: 'Employee Performance',
                        path: ROUTE.EMPLOYEE_REPORT_PERFORMANCE,
                        component: <EmployeePerformance />,
                        requirePermission: [REPORT_EMPLOYEE_REPORT],
                    },
                ],
            },
        },
    }
    const customerMenu: IMenu = {
        title: 'Customers',
        navs: {
            [AdminRouteName.customers]: {
                title: t('side_navigation.customers'),
                icon: <CustomerIcon />,
                component: CustomerAdminPage,
                path: ROUTE.CUSTOMERS_SETTING,
                redirectToPath: ROUTE.CUSTOMERS,
                requirePermission: [CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER],
                routes: [
                    {
                        label: 'Customers',
                        path: ROUTE.CUSTOMERS,
                        component: <CustomerAdmin />,
                        exact: true,
                        requirePermission: [
                            CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER,
                        ],
                    },
                    {
                        path: ROUTE.CUSTOMERS_NEW,
                        component: <NewCustomer />,
                        requirePermission: [
                            CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER,
                        ],
                    },
                    {
                        path: ROUTE.CUSTOMERS_EDIT,
                        component: <EditCustomer />,
                        requirePermission: [
                            CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER,
                        ],
                    },
                ],
            },
            [AdminRouteName.customerCategory]: {
                title: 'Customer categories',
                icon: <CustomerCategoryIcon />,
                path: ROUTE.CUSTOMERS_CATEGORIES,
                redirectToPath: ROUTE.CUSTOMERS_CATEGORIES_MAIN,
                requirePermission: [CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER],
                component: CustomerCategoriesPage,
                routes: [
                    {
                        label: 'Customer Categories',
                        path: ROUTE.CUSTOMERS_CATEGORIES_MAIN,
                        component: <CustomerCategoryAdmin />,
                        exact: true,
                        requirePermission: [
                            CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER,
                        ],
                    },
                    {
                        path: ROUTE.CUSTOMERS_CATEGORIES_NEW,
                        component: <EditCustomerCategory />,
                        requirePermission: [
                            CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER,
                        ],
                    },
                    {
                        path: ROUTE.CUSTOMERS_CATEGORIES_EDIT,
                        component: <EditCustomerCategory />,
                        requirePermission: [
                            CUSTOMER_MANAGEMENT_MANAGE_CUSTOMER,
                        ],
                    },
                ],
            },
            [AdminRouteName.customerLoyalty]: {
                title: 'Customer loyalty',
                icon: <MilitaryTechIcon />,
                path: ROUTE.CUSTOMERS_LOYALTY,
                redirectToPath: ROUTE.CUSTOMERS_LOYALTY_MANAGEMENT,
                requirePermission: [
                    CUSTOMER_MANAGEMENT_LOYALTY_SETTING_MANAGEMENT,
                ],
                moduleName: OPERATIONAL_SETTING.loyalty,
                component: CustomerLoyaltyPage,
                routes: [
                    {
                        label: 'Loyalty Management',
                        path: ROUTE.CUSTOMERS_LOYALTY_MANAGEMENT,
                        component: <LoyaltyManagement />,
                        requirePermission: [
                            CUSTOMER_MANAGEMENT_LOYALTY_SETTING_MANAGEMENT,
                        ],
                        exact: true,
                    },
                    {
                        label: 'Loyalty History',
                        path: ROUTE.CUSTOMERS_LOYALTY_HISTORY,
                        component: <LoyaltyHistory />,
                        requirePermission: [],
                    },
                ],
            },
        },
    }
    const settingMenu: IMenu = {
        title: 'Settings',
        navs: {
            [AdminRouteName.locationSetting]: {
                title: t('side_navigation.settings_this_location'),
                icon: <LocationSettingIcon />,
                path: ROUTE.LOCATION_SETTING,
                redirectToPath: `${ROUTE.SYSTEM_SETTING_GENERAL}`,
                component: SystemSetting,
                requirePermission: [
                    SYSTEM_SETUP_GENERAL,
                    SYSTEM_SETUP_FULTILLMENT_OPTIONS,
                    SYSTEM_SETUP_ORDER_CHANNEL,
                    ORDER_EVENT_MANAGE_ORDER_EVENT,
                    SYSTEM_SETUP_LOCATION_BRANDS,
                ],
                routes: [
                    {
                        label: 'General',
                        exact: true,
                        component: <GeneralSetting />,
                        path: `${ROUTE.SYSTEM_SETTING_GENERAL}`,
                        requirePermission: [SYSTEM_SETUP_GENERAL],
                    },
                    {
                        label: 'OrderWire Modules',
                        exact: true,
                        component: <OrderWireModules />,
                        path: `${ROUTE.SYSTEM_SETTING_OW_MODULES}`,
                        requirePermission: [SYSTEM_SETUP_ORDER_CHANNEL],
                    },
                    {
                        label: 'Order Event Routes',
                        exact: true,
                        component: <EventRouteSettings />,
                        path: `${ROUTE.SYSTEM_SETTING_EVENT_ROUTE_SETTINGS}`,
                        requirePermission: [ORDER_EVENT_MANAGE_ORDER_EVENT],
                    },
                    {
                        path: ROUTE.SYSTEM_SETTING_EVENT_ROUTE_SETTINGS_NEW,
                        exact: true,
                        component: <EventRouteEditor />,
                        requirePermission: [ORDER_EVENT_MANAGE_ORDER_EVENT],
                    },
                    {
                        path: ROUTE.SYSTEM_SETTING_EVENT_ROUTE_SETTINGS_EDIT,
                        exact: false,
                        component: <EventRouteEditor />,
                        requirePermission: [ORDER_EVENT_MANAGE_ORDER_EVENT],
                    },
                    {
                        label: 'Fulfillment Options',
                        exact: true,
                        component: <OrderfulfillmentOption />,
                        path: `${ROUTE.SYSTEM_SETTING_FULFILLMENT_OPTIONS}`,
                        requirePermission: [SYSTEM_SETUP_FULTILLMENT_OPTIONS],
                    },
                    {
                        label: 'Brands',
                        exact: false,
                        component: <LocationBrands />,
                        path: `${ROUTE.SYSTEM_SETTING_BRANDS}`,
                        requirePermission: [SYSTEM_SETUP_LOCATION_BRANDS],
                    },
                    {
                        label: 'Reset Sales',
                        exact: false,
                        component: <ResetSalesPage />,
                        path: `${ROUTE.SYSTEM_SETTING_RESET_SALES}`,
                        requirePermission: [SALES_RESET_SALES],
                    },
                ],
            },
            [AdminRouteName.companySetting]: {
                title: t('side_navigation.company_settings'),
                icon: <CompanySettingIcon />,
                path: ROUTE.COMPANY_SETTING,
                redirectToPath: ROUTE.COMPANY_COMPANY_AND_LOCATION_PROFILE,
                component: CompanySetting,
                requirePermission: [],
                routes: [
                    {
                        label: t(
                            'company_setting.label.company_location_profile',
                        ),
                        path: ROUTE.COMPANY_COMPANY_AND_LOCATION_PROFILE,
                        component: <MainUpdateCompany />,
                        exact: true,
                        requirePermission: [],
                    },
                    {
                        path: ROUTE.COMPANY_LOCATIONS_NEW,
                        component: <UpsertLocation />,
                        exact: true,
                        requirePermission: [],
                    },
                    {
                        path: ROUTE.COMPANY_LOCATIONS_EDIT,
                        component: <UpsertLocation />,
                        exact: true,
                        requirePermission: [],
                    },
                    {
                        label: t('company_setting.label.brands'),
                        path: ROUTE.COMPANY_BRANDS,
                        component: <Brands />,
                        exact: true,
                        requirePermission: [SYSTEM_SETUP_COMPANY_BRANDS],
                    },
                    {
                        path: ROUTE.COMPANY_BRANDS_NEW,
                        component: <UpsertBrands />,
                        requirePermission: [SYSTEM_SETUP_COMPANY_BRANDS],
                    },
                    {
                        path: ROUTE.COMPANY_BRANDS_EDIT,
                        component: <UpsertBrands />,
                        requirePermission: [SYSTEM_SETUP_COMPANY_BRANDS],
                    },
                    {
                        label: t('company_setting.label.subscription'),
                        path: ROUTE.COMPANY_SUBSCRIPTION,
                        component: <CompanySubscription />,
                        requirePermission: [SYSTEM_SETUP_SUBSCRIPTION],
                    },
                ],
            },
        },
    }
    let menus = {
        OperationMenu,
        ReportMenu,
        OnlineMenu,
        ProductSetupMenu,
        InventoryMenu,
        PosSettingMenu,
        DeviceMenu,
        FinancialMenu,
        PromotionMenu,
        EmployeeMenu,
        customerMenu,
        settingMenu,
    }

    //override permission from tab to the menu nav
    values(menus).forEach((menu) => {
        if (menus[MenuNames.settingMenu].title === menu.title) return
        const navs = values(menu.navs)
        navs?.forEach((nav) => {
            nav.requirePermission = nav.routes?.some((a) =>
                isEmpty(a.requirePermission),
            )
                ? []
                : nav.routes?.flatMap((a) => a.requirePermission) ?? []
        })
        menu.requirePermission = navs?.some((a) => isEmpty(a.requirePermission))
            ? []
            : navs?.flatMap((menu) => menu.requirePermission ?? []) ?? []
    })

    //Always display for company profile
    menus[MenuNames.settingMenu].requirePermission = []

    return menus
}
enum UserMenuNav {
    accountSetting = 'accountSetting',
    posTerminalPreference = 'posTerminalPreference',
    userPreference = 'userPreference',
}
const userPreferenceMenuNavs: () => {
    [key in UserMenuNav]: IMenuNav
} = () => {
    return {
        [UserMenuNav.accountSetting]: {
            title: 'My Account',
            path: ROUTE.MY_ACCOUNT,
            component: MyAccount,
            requirePermission: [],
            icon: <PersonIcon />,
        },
        [UserMenuNav.userPreference]: {
            title: 'User Preferences',
            path: ROUTE.USER_PREFERENCE,
            redirectToPath: `${ROUTE.USER_PREFERENCE}/security`,
            component: UserPreference,
            requirePermission: [],
            icon: <SettingIcon />,
        },
        [UserMenuNav.posTerminalPreference]: {
            title: 'Terminal Preferences',
            path: ROUTE.TERMINAL_PREFERENCE,
            redirectToPath: ROUTE.TERMINAL_PREFERENCE_PRINTING,
            component: TerminalPreference,
            requirePermission: [],
            icon: <DeviceIcon />,
            routes: [
                {
                    label: 'Printing',
                    path: ROUTE.TERMINAL_PREFERENCE_PRINTING,
                    requirePermission: [],
                    component: <TerminalPrintingSetting />,
                    exact: true,
                },
                {
                    label: 'Payment',
                    path: ROUTE.TERMINAL_PREFERENCE_PAYMENT,
                    requirePermission: [],
                    component: <TerminalPaymentSetting />,
                    exact: true,
                },
                {
                    label: 'Customer Facing Display',
                    path: ROUTE.TERMINAL_PREFERENCE_CUSTOMER_FACING_DISPLAY,
                    requirePermission: [],
                    moduleName: OPERATIONAL_SETTING.customerFacingDisplay,
                    component: <TerminalCustomerFacingDisplaySetting />,
                    exact: true,
                },
            ],
        },
    }
}

const useAdminRoute = () => {
    const { hasPermission } = usePermission()
    const { t } = useTranslation()
    const operationSetting: any = useAppSelector(
        (state) => state.operation.data,
    )
    // Get enabled (a.k.a. active) PostHog feature flags.
    const postHogFeatureFlags = useActiveFeatureFlags()

    const menus: MainMenuNav = useMemo(() => {
        const enabledFeatureFlags = getActiveFeatureFlags(postHogFeatureFlags)
        const menuGroups = getMenus(t)
        //set redirect to first tab that able to visit
        values(menuGroups)
            .flatMap((m) => values(m.navs ?? {}) || [])
            .forEach((nav) => {
                nav.routes =
                    !isModuleActive(nav, operationSetting) ||
                    !isFeatureFlagEnabled(nav, enabledFeatureFlags)
                        ? []
                        : nav.routes
                              ?.filter((r) =>
                                  isModuleActive(r, operationSetting),
                              )
                              ?.filter((r) =>
                                  hasPermission(r.requirePermission),
                              )
                              ?.filter((r) =>
                                  isFeatureFlagEnabled(r, enabledFeatureFlags),
                              ) ?? []
                const tabs = nav.routes?.filter((r) => r.label) ?? []
                for (let i = 0; i < tabs.length; i++) {
                    if (nav.path !== tabs[i].path) {
                        nav.redirectToPath = tabs[i].path
                        break
                    }
                }
            })

        return menuGroups
    }, [hasPermission, operationSetting, t, postHogFeatureFlags])
    const userPreferenceMenus = useMemo(() => {
        const menus = userPreferenceMenuNavs()
        values(menus).forEach((nav) => {
            nav.routes = isModuleActive(nav, operationSetting)
                ? nav.routes
                      ?.filter((r) => isModuleActive(r, operationSetting))
                      ?.filter((r) => hasPermission(r.requirePermission)) ?? []
                : []
            const tabs = nav.routes?.filter((r) => r.label) ?? []
            for (const tab of tabs) {
                if (nav.path !== tab.path) {
                    nav.redirectToPath = tab.path
                    break
                }
            }
        })
        return menus
    }, [hasPermission, operationSetting])

    const adminRoutes: IRoute[] = useMemo(
        () => [
            ...values(userPreferenceMenus),
            ...values(menus).flatMap((m) => values(m.navs ?? {}) || []),
        ],
        [menus, userPreferenceMenus],
    )

    return { adminRoutes, menus, userPreferenceMenus }
}
export default useAdminRoute

function isModuleActive(
    route: ILinkTab,
    operationSetting: OperationalSettingContract,
): unknown {
    if (!route?.moduleName) return true
    return get(operationSetting, route.moduleName, false)
}

function isFeatureFlagEnabled(
    route: ILinkTab,
    enabledFeatureFlags: Set<FeatureFlag>,
): unknown {
    if (!route?.featureFlags) return true
    // All feature flags specified for the route need to be enabled.
    return route.featureFlags.every((f) => enabledFeatureFlags.has(f))
}
